import { useGet } from 'restful-react'

const useConfirmCode = (code: string, email: string) => {
    return useGet(`/user/lgpdconfirmationcodeverify/${code}/${email}`, {
        lazy: true
    })
}

export default useConfirmCode
